import { Link, useLocation } from 'react-router-dom';

interface BreadcrumbItem {
  label: string;
  href?: string;
}

interface BreadcrumbProps {
  items?: BreadcrumbItem[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  const location = useLocation();

  // Auto-generate breadcrumbs from path if not provided
  const defaultItems: BreadcrumbItem[] = [{ label: '首页', href: '/' }];
  if (!items) {
    const pathParts = location.pathname.split('/').filter(Boolean);
    if (pathParts.length > 0) {
      // Add category/article paths
      let currentPath = '';
      pathParts.forEach((part) => {
        currentPath += `/${part}`;
        if (part.startsWith('category')) {
          defaultItems.push({ label: '分类', href: currentPath });
        } else if (part.startsWith('article')) {
          defaultItems.push({ label: '文章', href: currentPath });
        } else if (part.startsWith('about')) {
          defaultItems.push({ label: '关于我们', href: currentPath });
        } else {
          // For slug-like paths, just show as current (no href)
          defaultItems.push({ label: part });
        }
      });
    }
  }

  const breadcrumbItems = items || defaultItems;
  const currentItem = breadcrumbItems[breadcrumbItems.length - 1];

  return (
    <nav aria-label="面包屑导航" className="py-3 px-4 md:px-6">
      <ol
        className="flex items-center gap-1.5 text-sm flex-wrap"
        itemScope
        itemType="https://schema.org/BreadcrumbList"
      >
        {breadcrumbItems.map((item, index) => (
          <li
            key={index}
            className="flex items-center gap-1.5"
            itemProp="itemListElement"
            itemScope
            itemType="https://schema.org/ListItem"
          >
            {index > 0 && (
              <span className="text-foreground-300">
                <i className="ri-arrow-right-s-line" />
              </span>
            )}
            {item.href && item.label !== currentItem.label ? (
              <Link
                to={item.href}
                className="text-foreground-500 hover:text-primary-500 transition-colors"
                itemProp="item"
              >
                <span itemProp="name">{item.label}</span>
              </Link>
            ) : (
              <span className="text-foreground-700 font-medium" itemProp="name">
                {item.label}
              </span>
            )}
            <meta itemProp="position" content={`${index + 1}`} />
          </li>
        ))}
      </ol>
    </nav>
  );
}